import React, { useState, useMemo } from 'react'
import { Input } from 'antd'
import debounce from 'lodash/debounce'
import { SearchOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

interface IProps {
  onSearch?: (value: any) => void
  placeholder?: string
  searchName?: string
  duration?: number
  [key: string]: any
}

const DebounceSearch = ({
  onSearch,
  placeholder,
  searchName = '',
  duration = 500,
  ...restProps
}: IProps) => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const originKeyword = searchParams.get(searchName)
  const [searchTerm, setSearchTerm] = useState(originKeyword || '')

  const handleSearch = useMemo(
    () =>
      debounce((value: any) => {
        typeof onSearch === 'function' && onSearch(value)
        if (searchName) {
          searchParams.set(searchName, value)
          setSearchParams(searchParams, { replace: true })
        }
      }, duration),
    [searchParams]
  )

  const handleChange = (event: any) => {
    const { value } = event.target
    setSearchTerm(value)
    handleSearch(value)
  }

  return (
    <Input
      placeholder={placeholder || t('ikg.input', { name: '' })}
      value={searchTerm}
      onChange={handleChange}
      suffix={<SearchOutlined style={{ color: '#d9d9d9' }} />}
      {...restProps}
    />
  )
}

export default DebounceSearch
